/**
 * Palette colori per le etichette email condivise.
 *
 * Unico hardcoding ammesso nel modulo etichette: e' una costante di design
 * (12 colori ben distinguibili, adatti a badge/chip su sfondo chiaro),
 * NON un elenco di etichette. Le etichette stesse restano dati (CRUD
 * /email/etichette): il picker in cui l'utente sceglie il colore alla
 * creazione/modifica pesca da qui.
 */
export const ETICHETTE_PALETTE: string[] = [
  '#ef4444', // rosso
  '#f97316', // arancio
  '#f59e0b', // ambra
  '#eab308', // giallo
  '#84cc16', // lime
  '#22c55e', // verde
  '#14b8a6', // verde acqua
  '#06b6d4', // ciano
  '#3b82f6', // blu
  '#6366f1', // indaco
  '#a855f7', // viola
  '#ec4899', // rosa
];
